"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useData = require("./useData");
Object.keys(_useData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useData[key];
    }
  });
});
var _useGetFeedbackBenefitBanners = require("./useGetFeedbackBenefitBanners");
Object.keys(_useGetFeedbackBenefitBanners).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetFeedbackBenefitBanners[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetFeedbackBenefitBanners[key];
    }
  });
});
var _useGetSharingLink = require("./useGetSharingLink");
Object.keys(_useGetSharingLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetSharingLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetSharingLink[key];
    }
  });
});
var _useTranslations = require("./useTranslations");
Object.keys(_useTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslations[key];
    }
  });
});
var _useGetCatalogueSharingLink = require("./useGetCatalogueSharingLink");
Object.keys(_useGetCatalogueSharingLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetCatalogueSharingLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetCatalogueSharingLink[key];
    }
  });
});
var _useGetPdpDynamicLink = require("./useGetPdpDynamicLink");
Object.keys(_useGetPdpDynamicLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetPdpDynamicLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetPdpDynamicLink[key];
    }
  });
});
